import { MdsIconKind } from "@/design-system/components/icon";
import { MDSIconButton, MDSIconButtonSize, MDSIconButtonVariant } from "@/mds/components/buttons";
import {
  StyledSectionHeaderContainer,
  StyledSectionItemContainerLeft,
  StyledSectionItemContainerRight,
} from "@/mds/components/sidebar/sidebar-section.styles";
import { MDSSidebarSectionHeaderSlotName } from "@/mds/components/sidebar/sidebar.types";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import { getSlot } from "@/mds/utils/slots";
import styled from "@emotion/styled";
import { ReactNode, useState } from "react";
import { ButtonProps } from "react-aria-components";

interface MDSSidebarSectionHeaderProps extends Exclude<ButtonProps, "children"> {
  defaultIconKind: MdsIconKind;
  label: string;
  children?: ReactNode;
  isExpanded: boolean;
  isDisabled?: boolean;
}

export const MDSSidebarSectionHeader = ({
  defaultIconKind,
  label,
  isExpanded,
  ...props
}: MDSSidebarSectionHeaderProps) => {
  const rightButtons = getSlot(props.children, MDSSidebarSectionHeaderSlotName.ButtonsRight);
  const [isHovered, setIsHovered] = useState(false);
  const iconKind = isExpanded
    ? MdsIconKind.CaretDown
    : isHovered
      ? MdsIconKind.CaretRight
      : defaultIconKind;

  return (
    <StyledSectionHeaderContainer
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      {...props}
    >
      <StyledSectionItemContainerLeft>
        <StyledSectionHeaderIconButton
          size={MDSIconButtonSize.XSmall}
          variant={MDSIconButtonVariant.OnChrome}
          iconKind={iconKind}
          onPress={props.onPress}
          rounded
        />
        <MDSText
          variant={MDSTextVariant.TextXs}
          weight={MDSTextWeight.SemiBold}
          color={MDSTextColor.Secondary}
        >
          {label}
        </MDSText>
      </StyledSectionItemContainerLeft>
      {rightButtons && (
        <StyledSectionItemContainerRight data-right-buttons>
          {rightButtons}
        </StyledSectionItemContainerRight>
      )}
    </StyledSectionHeaderContainer>
  );
};

const StyledSectionHeaderIconButton = styled(MDSIconButton)`
  & .mds-icon {
    font-size: 12px;
    height: 12px;
    width: 12px;
  }
`;
